var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/prefer-default-export */
import styled, { keyframes } from 'styled-components';
var flipInY = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   0% {\n    transform: perspective(1000px) rotateY(90deg);\n    animation-timing-function: linear;\n  }\n  to {\n    transform: perspective(1000px);\n  }\n"], ["\n   0% {\n    transform: perspective(1000px) rotateY(90deg);\n    animation-timing-function: linear;\n  }\n  to {\n    transform: perspective(1000px);\n  }\n"])));
export var FlipperWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation-duration: 0.3s;\n  animation-name: ", ";\n  border-radius: 15px;\n"], ["\n  animation-duration: 0.3s;\n  animation-name: ", ";\n  border-radius: 15px;\n"])), function (_a) {
    var shouldAnimate = _a.shouldAnimate;
    if (shouldAnimate) {
        return flipInY;
    }
    return 'none';
});
var templateObject_1, templateObject_2;
